import * as React from 'react';

const Stopwatch24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M18 8L19 7M19 6L20 7M12 5.5V2M14 2H10M12 14.75L8.5625 10.9449M20.25 14.25C20.25 18.8063 16.5563 22.5 12 22.5C7.44365 22.5 3.75 18.8063 3.75 14.25C3.75 9.69365 7.44365 6 12 6C16.5563 6 20.25 9.69365 20.25 14.25Z'
				stroke='#333333'
				strokeWidth='1.375'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export { Stopwatch24 };
